import React from 'react'

import { GeneralResponse } from 'protos'

type AutoSubContext = {
  remainingSubs: number
  isAcknowledged: boolean
  ackAutosubIntro: () => Promise<GeneralResponse>
  onStoreClick: () => void
}

const AutoSubContext = React.createContext<AutoSubContext>({
  remainingSubs: 0,
  isAcknowledged: false,
  ackAutosubIntro: () => Promise.resolve(GeneralResponse.fromObject({ result: GeneralResponse.Result.GR_SUCCESS })),
  onStoreClick: () => { /* noop */ },
})

export const AutoSubProvider = AutoSubContext.Provider

export type InjectedAutoSubProps = AutoSubContext

export const withAutoSub = <P extends {}>(
  WrappedComponent: React.ComponentType<P & AutoSubContext>,
): React.ComponentType<P> => (wrappedProps) => (
  <AutoSubContext.Consumer>
    {(props) => <WrappedComponent {...wrappedProps} {...props} />}
  </AutoSubContext.Consumer>
)
try {
    // @ts-ignore
    withAutoSub.displayName = "withAutoSub";
    // @ts-ignore
    withAutoSub.__docgenInfo = { "description": "", "displayName": "withAutoSub", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/contexts/AutoSub.tsx#withAutoSub"] = { docgenInfo: withAutoSub.__docgenInfo, name: "withAutoSub", path: "src/contexts/AutoSub.tsx#withAutoSub" };
}
catch (__react_docgen_typescript_loader_error) { }